import React from 'react';

export default class AppComponent extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      permission: {
        can_read: false,
        can_update: false
      }
    }

  }

  setPermission = () => {
    if(this.props.user && this.props.user.plan_permissions){
      var id = this.state.planId || this.state.templateId
      var permission = this.getObject(this.props.user.plan_permissions, parseInt(id, 10), 'plan_id')
      this.setState({
        permission: permission
      })
    }
  }

  getPermission = (id) => {
    const permission = this.getObject(this.props.user.plan_permissions, id, 'plan_id');
    return permission ? permission : null;
  }

  getObject = (objectArray, value, attr) => {
    return objectArray.find(function(obj, index, arr){
      return obj[attr] === value
    })
  }

  reloadLanguageTranslations = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const language = urlParams.get('language');
    if (language){
      this.props.getTranslations(language);
    }
  }

  autoPositionElement = (evt, element) => {
    var body = document.body, html = document.documentElement;

    var width = Math.max( body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth );
    var height = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );

    let xOffset = Math.max(html.scrollLeft, body.scrollLeft);
    let yOffset = Math.max(html.scrollTop, body.scrollTop);

    var elementOffsetWidth = evt.type === 'click' ? element.offsetWidth : 0
    var elementOffsetHeight = evt.type === 'click' ? element.offsetHeight : 0

    var left, top
    if (evt.clientX + xOffset + elementOffsetWidth > width) {
      left = evt.clientX + xOffset - elementOffsetWidth
    } else {
      left = evt.clientX + xOffset
    }

    if (evt.clientY + yOffset + elementOffsetHeight > height) {
      top = evt.clientY + yOffset - elementOffsetHeight
    } else {
      top = evt.clientY + yOffset
    }

    element.style.left = `${left}px`
    element.style.top = `${top}px`
    element.style.visibility = 'visible'   
    element.addEventListener('mouseleave', ()=>{ element.style.visibility = 'hidden'; } );
  }

  toggleNewEntryForm = (show) => {
    this.setState({ showNewEntryForm: show })
  }

  getRequiredFormKeys = () => {
    const { languageName } = this.props.risk
    if (languageName==='English'){
      return ['work_phase_or_ambient_exposure', 'activity', 'hazard', 'unwanted_event']
    } else {
      return Object.keys({...this.props.risk}).filter((key)=>{ return (key.includes('work_phase') || key.includes('activity') || key.includes('hazard') || key.includes('unwanted_event')) && key!=='activityGroup' && key.includes(languageName.toLowerCase()) })
    }
  }

  render() {
    return 
  }
}


// WEBPACK FOOTER //
// ./src/components/app_component.js